import ApiCashflow from '../../apis/Cashflow'

import Tools from '../../helpers/Tools'

export default {
    namespaced: true,
    state: {
        dateFilter: null,
        cashCurrent: null,
        cashData: [],
        incomes: [],
        expenses: [],
        payments: [],
        salesCash: [],
        salesCards: [],
        balanceFavors: [],
        totalIncomes: 0,
        totalExpenses: 0,
        totalPayments: 0,
        totalSalesCash: 0,
        totalSalesCards: 0,
        totalSales: 0,
        totalCash: 0,
        totalMoney: 0,
        totalCards: 0,
        totalYapes: 0,
        totalTrans: 0,
        totalPlins: 0,
        cashSelected: null,
    },
    mutations: {
        setDateFilter(state, dateFilter) {
            state.dateFilter = dateFilter
        },
        setBalanceFavors(state, balanceFavors) {
            state.balanceFavors = balanceFavors
        },
        setTotalMoney(state, totalMoney) {
            state.totalMoney = totalMoney
        },
        setTotalCards(state, totalCards) {
            state.totalCards = totalCards
        },
        setTotalTrans(state, totalTrans) {
            state.totalTrans = totalTrans
        },
        setTotalYapes(state, totalYapes) {
            state.totalYapes = totalYapes
        },
        setTotalPlins(state, totalPlins) {
            state.totalPlins = totalPlins
        },
        setTotalCash(state, totalCash) {
            state.totalCash = totalCash
        },
        setCashCurrent(state, cashCurrent) {
            state.cashCurrent = cashCurrent
        },
        setCashData(state, cashData) {
            state.cashData = cashData
        },
        setIncomes(state, incomes) {
            state.incomes = incomes
        },
        setExpenses(state, expenses) {
            state.expenses = expenses
        },
        setPayments(state, payments) {
            state.payments = payments
        },
        setSalesCash(state, salesCash) {
            state.salesCash = salesCash
        },
        setSalesCards(state, salesCards) {
            state.salesCards = salesCards
        },
        setTotalIncomes(state, totalIncomes) {
            state.totalIncomes = totalIncomes
        },
        setTotalExpenses(state, totalExpenses) {
            state.totalExpenses = totalExpenses
        },
        setTotalPayments(state, totalPayments) {
            state.totalPayments = totalPayments
        },
        setTotalSalesCash(state, totalSalesCash) {
            state.totalSalesCash = totalSalesCash
        },
        setTotalSalesCards(state, totalSalesCards) {
            state.totalSalesCards = totalSalesCards
        },
        setTotalSales(state, totalSales) {
            state.totalSales = totalSales
        },
        set_cashSelected (state, data) {
            state.cashSelected = data;
        }
    },
    actions: {
        runSetDateFilter({commit}, dateFilter) {
            commit('setDateFilter', dateFilter)
        },
        openCash({commit}, params) {
            ApiCashflow.open(params)
                    .then(({data}) => {
                        commit('setCashCurrent', data)
                    })
        },
        getCashCurrent({commit}) {
            ApiCashflow.getCurrent()
                    .then(({data}) => {
                        commit('setCashCurrent', data)
                    })
        },
        getPayments({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getPayments(state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setPayments', data)
                    })
        },
        getSalesCash({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getSales('CASH', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setSalesCash', data)
                    })
        },
        getSalesYapes({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getSales('YAPE', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setSalesCash', data)
                    })
        },
        getSalesPlins({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getSales('PLIN', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setSalesCash', data)
                    })
        },
        getSalesTransferencias({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getSales('TRANSFERENCIA', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setSalesCash', data)
                    })
        },
        getSalesCards({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getSales('TARJETAS', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setSalesCards', data)
                    })
        },
        getIncomes({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getOperations('income', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setIncomes', data)
                    })
        },
        getExpenses({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getOperations('expense', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setExpenses', data)
                    })
        },
        getBalanceFavor({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getOperations('balance_favor', state.dateFilter, cash_id)
                    .then(({data}) => {
                        commit('setCashData', data)
                        commit('setBalanceFavors', data)
                    })
        },
        getTotalAmount({commit, state}, cash_id) {
            if(!state.dateFilter) {
                commit('setDateFilter', Tools.prepareCurrentDate())
            }
            ApiCashflow.getTotalAmounst(state.dateFilter, cash_id)
                    .then( ({data}) => {
                        commit('setTotalCash', data.totalCash)
                        commit('setTotalIncomes', data.totalIncomes)
                        commit('setTotalExpenses', data.totalExpenses)
                        commit('setTotalPayments', data.totalPayments)
                        commit('setTotalSalesCash', data.totalSalesCash)
                        commit('setTotalSalesCards', data.totalSalesCards)
                        commit('setTotalMoney', data.totalMoney)
                        commit('setTotalCards', data.totalCards)
                        commit('setTotalTrans', data.totalTrans)
                        commit('setTotalYapes', data.totalYapes)
                        commit('setTotalPlins', data.totalPlins)
                    } )
        },
        selectCash({commit}, data) {
            commit('set_cashSelected', data);
        }
    }
}